/* eslint-disable react/prop-types */
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './ProximityToClockInRequiredDialogStyles';

import { mdiMapMarkerOff } from '@mdi/js';
import Icon from '@mdi/react';
import { useDispatch } from 'react-redux';
import { closeProximityToClockInRequiredDialog } from 'store/records/actions/records.actions';
import { clockInRecord } from 'store/records/thunks/clockInRecord.thunk';

const styles = (theme) => ({
  dialogPaper: {
    background: theme.palette.primary.main,
    position: 'initial',
    overflow: 'initial',
  },
  editHeader: {
    background: theme.palette.primary.gradient,
  },
  dialogContent: {
    paddingTop: 8,
    paddingBottom: 32,
    [theme.breakpoints.down('xs')]: {
      padding: '0 8px 8px 8px',
    },
  },
  dialogActions: {
    [theme.breakpoints.down('xs')]: {
      margin: 4,
    },
  },
  gridContainer: {},
  gridItem: {
    padding: '0 8px',
  },
  gridImage: {
    marginTop: '25px',
    textAlign: 'center',
  },
  select: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    maxWidth: '120px',
    marginLeft: '16px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '80px',
    },
  },
  button: {
    display: 'block',
    width: '300px',
    marginTop: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  loading: {
    ...theme.component.dashboardButtonIcon,
  },
});

/**
 * LocationMust is a dialog which opens when location is mandatory, but isn't enabled by the user
 * @param {project, onClose, open} props
 */
function ProximityToClockInRequiredDialog({ project, open }) {
  const dispatch = useDispatch();
  console.log('ProximityToClockInRequiredDialog render', project);

  const { t } = useTranslation('common');
  const classes = useStyles();
  const [bypassDisabled, setBypassDisabled] = useState(true);
  const [bypassText, setBypassText] = useState(3);
  const countdownRef = useRef(null);

  function bypassLocation() {
    setBypassDisabled(true);
    setBypassText(3);
    countdownRef.current = setInterval(() => {
      if (bypassText > 1) {
        setBypassText((prev) => prev - 1);
      }
    }, 1000);
  }

  const onClose = () => {
    dispatch(closeProximityToClockInRequiredDialog());
  };

  useEffect(() => {
    if (bypassText < 1) {
      clearInterval(countdownRef.current);
      setBypassText('Leimaa silti');
      setBypassDisabled(false);
    }
  }, [bypassText]);

  useEffect(() => {
    if (bypassDisabled === true) {
      bypassLocation();
    }

    return () => {
      clearInterval(countdownRef.current);
    };
  }, []);

  const clockInWithOutLocation = () => {
    dispatch(
      clockInRecord({
        projectId: project.id,
        allowClockInWithoutLocation: true,
      })
    );
    dispatch(closeProximityToClockInRequiredDialog());
  };

  return (
    <Dialog
      disableBackdropClick
      classes={{ paper: classes.dialogPaper }}
      open={open}
      onClose={onClose}
      aria-labelledby="contact-edit-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogHeader
        icon={<Icon path={mdiMapMarkerOff} size={1} className={classes.icon} />}
        title={t('location.proximity_on_clock_in_required')}
        onClose={onClose}
      />
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={0} className={classes.gridContainer}>
          <Grid item xs={12} container justifyContent="flex-start">
            <Typography>
              {t('location.proximity_on_clock_in_required_explanation')}
            </Typography>
          </Grid>

          <Grid item xs={12} container justifyContent="flex-start">
            <br />
          </Grid>
          <Grid item xs={12} container justifyContent="flex-start">
            {project.contact_phone && (
              <Typography>{`${t('location.location_must_explanation3')} ${
                project.contact_first_name || ''
              } ${project.contact_last_name || ''} ${
                project.contact_phone
              }`}</Typography>
            )}
            {!project.contact_phone && (
              <Typography>
                {t('location.location_must_explanation3_alternative')}
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions className={classes.dialogActions}>
        {project.proximityToClockInRequiredSkipAllowed && (
          <Button
            onClick={clockInWithOutLocation}
            className={classes.actionBtn}
            style={{ minWidth: '100px' }}
            color="danger"
            disabled={bypassDisabled}
          >
            {bypassText}
          </Button>
        )}
        <Button
          onClick={onClose}
          className={classes.actionBtn}
          outline
          color="primary"
        >
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(ProximityToClockInRequiredDialog);
